exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.header .logo[data-v-6b7e1dfa] {\n  width: 180px;\n  margin-top: -10px;\n  position: absolute;\n  left: 180px;\n}\n.header .center[data-v-6b7e1dfa] {\n  width: 1000px;\n  height: 80px;\n  margin: 0 auto;\n}\n", "", {"version":3,"sources":["/home/ferry/ONLINE_SERVICE/other/ferry/task_workspace/baidu/ps-aladdin/med-health-pc/src/components/app/Header.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,cAAc;EACd,aAAa;EACb,eAAe;CAChB","file":"Header.vue","sourcesContent":["\n.header .logo[data-v-6b7e1dfa] {\n  width: 180px;\n  margin-top: -10px;\n  position: absolute;\n  left: 180px;\n}\n.header .center[data-v-6b7e1dfa] {\n  width: 1000px;\n  height: 80px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b7e1dfa","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/Header.vue
// module id = I5Nt
// module chunks = 1